"use client";

import {
  Card,
  Stack,
  Text,
  Title,
  useComputedColorScheme,
} from "@mantine/core";
import { estimateReadMinutesFromHtml } from "@utils/blogReading";
import dayjs from "dayjs";
import Image from "next/image";
import Link from "next/link";
import type { BlogArticleListItem } from "@tsTypes/blog-schema";
import classes from "./blog.module.css";

export default function BlogCard({ article }: { article: BlogArticleListItem }) {
  const colorScheme = useComputedColorScheme("light");
  const excerpt =
    article.metaDescription?.slice(0, 160) ??
    "Read this article on the Tiber Tutor blog.";
  const dateLabel = article.createdAt
    ? dayjs(article.createdAt).format("D MMM YYYY")
    : null;
  const readMinutes = estimateReadMinutesFromHtml(article.body);

  return (
    <Card
      component={Link}
      href={`/blog/${article.slug}`}
      shadow="md"
      padding="lg"
      radius="md"
      withBorder
      className={classes.card}
    >
      <Card.Section className={classes.cardImageSection}>
        {article.heroImageUrl ? (
          <Image
            src={article.heroImageUrl}
            alt=""
            width={640}
            height={360}
            className={classes.cardImage}
            sizes="(max-width: 768px) 100vw, 33vw"
          />
        ) : (
          <div className={classes.cardPlaceholder} data-theme={colorScheme} />
        )}
        {dateLabel ? (
          <Text component="span" className={`${classes.imageCornerMeta} ${classes.imageCornerMetaLeft}`}>
            {dateLabel}
          </Text>
        ) : null}
        <Text component="span" className={`${classes.imageCornerMeta} ${classes.imageCornerMetaRight}`}>
          {readMinutes} min read
        </Text>
      </Card.Section>
      <Stack gap="xs" mt="md">
        <Text size="sm" c="dimmed" lineClamp={3}>
          {excerpt}
        </Text>
      </Stack>
    </Card>
  );
}
